import PhxHeader from "@phoenixreisen/mithrils/src/header";
import m from "mithril";
export const LoginBox = {
    view({ children }) {
        return (m("section", { class: "login" },
            m("article", { class: "login-box wrapper" },
                m("header", { class: "login-box__header" },
                    m(PhxHeader, null),
                    m("h1", null, "Mitarbeiter")),
                children)));
    },
};
export default LoginBox;
